module.exports = __webpack_public_path__ + "img/top-img-sns.cd3d091e.webp";